/**
 * Carousels whose images should open for choosing when they next appear (a
 * carousel just added from the picker), and a way for menus to open a
 * carousel's images while it's on the page.
 */
export const pendingCarouselPicker = new Set<string>();
export const openCarouselPickerOnArrival = (sourceBlockId: string) =>
  pendingCarouselPicker.add(sourceBlockId);

const EDIT_EVENT = "hazumu:carousel-edit";
export const editCarouselImages = (sourceBlockId: string) =>
  window.dispatchEvent(new CustomEvent(EDIT_EVENT, { detail: sourceBlockId }));
export const onEditCarouselImages = (sourceBlockId: string, open: () => void) => {
  const listener = (event: Event) => {
    if ((event as CustomEvent<string>).detail === sourceBlockId) open();
  };
  window.addEventListener(EDIT_EVENT, listener);
  return () => window.removeEventListener(EDIT_EVENT, listener);
};
